import { formatAddress, getReportingYear } from "./shared";
import { BaseNewlyNotReportingTemplate } from "./baseNewlyNotReportingTemplate";
export class NewlyNotReportingSingleTemplate extends BaseNewlyNotReportingTemplate {
    subject(params) {
        return this.buildSubject(params.communication);
    }
    getSingleFacility(params) {
        const { communication } = params;
        if (communication.facilities.length === 0) {
            throw new Error("Newly-not-reporting single-facility template requires one facility");
        }
        const facility = communication.facilities[0];
        return {
            name: facility.name,
            address: formatAddress(facility),
            organizationName: communication.tenant.name,
            reportingYear: getReportingYear(communication),
        };
    }
}
//# sourceMappingURL=singleTemplate.js.map